import axios from "axios";
import { RESERVATION_BASE_URL } from "../utils/EmpUtil";

export default class DealerActionsClient {
  static baseUrl = RESERVATION_BASE_URL;

  static actionOnOrder(dealerCommonId, dealerActionInfo, dealerUserId) {
    dealerCommonId = dealerCommonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/${dealerCommonId}/customer-orders?dealerUserId=${dealerUserId}`;

    return axios.post(url, dealerActionInfo);
  }

  static acceptRequestAndDeposit(
    dealerCommonId,
    dealerActionInfo,
    dealerUserId
  ) {
    dealerCommonId = dealerCommonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/${dealerCommonId}/accept-order-deposit?dealerUserId=${dealerUserId}`;

    return axios.post(url, dealerActionInfo);
  }

  static saveDealerAction(dealerCommonId, dealerActionInfo, dealerUserId) {
    dealerCommonId = dealerCommonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/${dealerCommonId}/save-dealer-actions?dealerUserId=${dealerUserId}`;

    // Errors, including 401s, go back to the caller; dealer actions never log
    // the user out
    return axios.post(url, dealerActionInfo).then(() => {});
  }
}
